import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'
import {useHistory} from 'react-router-dom'
import {Theme} from '../../../app/theme'
import {navigate} from '../links/navigate'

interface ArServiceButtonProps {
  readonly text: string
  readonly link: string
  readonly variant: 'filled' | 'outlined'
  readonly compact?: boolean
  readonly onClick?: () => void
}

const BUTTON_WIDTH = 400
const COMPACT_PADDING_Y = 4
const COMPACT_PADDING_X = 30

export function ArServiceButton({text, link, variant, compact = false, onClick}: ArServiceButtonProps) {
  const {css, theme} = useFela<Theme>()
  const history = useHistory()

  const filled = variant === 'filled'
  const color = filled ? theme.colors.textInverted : theme.colors.text

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick?.()
    navigate(link, history)
  }

  const buttonStyle: IStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: compact ? 'auto' : BUTTON_WIDTH,
    maxWidth: '100%',
    minHeight: compact ? 0 : 64,
    paddingTop: compact ? COMPACT_PADDING_Y : theme.spacing.space3,
    paddingBottom: compact ? COMPACT_PADDING_Y : theme.spacing.space3,
    paddingLeft: compact ? COMPACT_PADDING_X : theme.spacing.space4,
    paddingRight: compact ? COMPACT_PADDING_X : theme.spacing.space4,
    borderRadius: 10,
    border: `2px solid ${theme.colors.primaryLight}`,
    backgroundColor: filled ? theme.colors.primaryLight : 'transparent',
    color,
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    ':visited': {color},
    ':hover': {color, textDecoration: 'none'},
    ':active': {color},
  }

  return (
    <a href={link} className={css(buttonStyle)} onClick={handleClick}>
      {text}
    </a>
  )
}
